export default function config($routeProvider)
{
	$routeProvider
		.when('/standard/pax', {
			template: require('./../../views/html/standard-report.html'),
			controller: 'PaxReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/group-pax', {
			template: require('./../../views/html/standard-report.html'),
			controller: 'GroupPaxReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/fit-pax', {
			template: require('./../../views/html/standard-report.html'),
			controller: 'FitPaxReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/groups', {
			template: require('./../../views/html/standard-report.html'),
			controller: 'GroupsReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/international', {
			template: require('./../../views/html/standard-report.html'),
			controller: 'InternationalReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/domestic', {
			template: require('./../../views/html/standard-report.html'),
			controller: 'DomesticReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/day-tripper', {
			template: require('./../../views/html/standard-report.html'),
			controller: 'DayTripperReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/state', {
			template: require('./../../views/html/overview-report.html'),
			controller: 'StateReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/country', {
			template: require('./../../views/html/overview-report.html'),
			controller: 'CountryReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/accommodation', {
			template: require('./../../views/html/overview-report.html'),
			controller: 'AccommodationReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/transport', {
			template: require('./../../views/html/overview-report.html'),
			controller: 'TransportReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/airline', {
			template: require('./../../views/html/overview-report.html'),
			controller: 'AirlineReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/referral', {
			template: require('./../../views/html/overview-report.html'),
			controller: 'ReferralReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/organisation-groups', {
			template: require('./../../views/html/overview-report.html'),
			controller: 'OrganisationGroupsReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/standard/organisation-pax', {
			template: require('./../../views/html/overview-report.html'),
			controller: 'OrganisationPaxReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/snapshot', {
			template: require('./../../views/html/snapshot-report.html'),
			controller: 'SnapshotReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/custom', {
			template: require('./../../views/html/custom-report.html'),
			controller: 'CustomReportController',
			controllerAs: 'reportCtrl',
			resolve: {
				check: function($location) {
					if (!window.admin) {
						alert('You do not have access to this page');
						$location.path('/records/create');
					}
				}
			}
		})
		.when('/records', {
			template: require('./../../views/html/records/index.html'),
			controller: 'RecordController',
			controllerAs: 'recordCtrl'
		})
		.when('/records/create', {
			template: require('./../../views/html/records/form.html'),
			controller: 'CreateController',
			controllerAs: 'formCtrl'
		})
		.when('/records/:id/edit', {
			template: require('./../../views/html/records/form.html'),
			controller: 'EditController',
			controllerAs: 'formCtrl'
		})
		.when('/settings', {
			template: require('./../../views/html/settings.html'),
			controller: 'SettingController',
			controllerAs: 'settingCtrl'
		})
		.when('/', {
			resolve: {
				check: function($location) {
					if (window.admin) {
						$location.path('/standard/pax');
					} else {
						$location.path('/records/create');
					}
				}
			}
		})
		.otherwise('/');
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/routes.js
 **/